<template>
  <!-- 仅 checkbox(多选)渲染角标勾选框;radio(单选)的选中反馈由卡片整体边框+背景高亮表达,故无角标 -->
  <div
    v-if="controlType === 'checkbox'"
    :class="cls.selection"
    :style="rootStyle"
  >
    <JdCheckbox :model-value="checked" :disabled="disabled" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type CSSProperties, type PropType } from 'vue'
import JdCheckbox from '../../../checkbox'
import type { StatisticCardControlType } from '../types'
import { SELECTION_TOP_OFFSET, SELECTION_RIGHT_OFFSET, STATISTIC_CARD_CLASSES } from '../constants'

export default defineComponent({
  name: 'StatisticCardSelection',
  components: { JdCheckbox },
  props: {
    controlType: { type: String as PropType<StatisticCardControlType>, default: null },
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  setup() {
    const cls = STATISTIC_CARD_CLASSES

    const rootStyle: CSSProperties = {
      position: 'absolute',
      top: `${SELECTION_TOP_OFFSET}px`,
      right: `${SELECTION_RIGHT_OFFSET}px`,
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }

    return {
      cls,
      rootStyle,
    }
  },
})
</script>